export { fileTypes };
const fileTypes = ['.page', '.page.server', '.page.route', '.page.client'];
